import { z } from 'zod'

export const PaymentStatusDtoSchema = z.union([z.literal('paid'), z.literal('partially_paid'), z.literal('not_paid')])

export type PaymentStatusDto = z.infer<typeof PaymentStatusDtoSchema>
